import React, { useEffect, useState } from 'react';
import {
  Breadcrumb,
  Button,
  ConfigProvider,
  Form,
  Input,
  Space,
  Switch,
  Select,
} from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import plPL from 'antd/lib/locale/pl_PL';
import 'moment/locale/pl';
import 'moment-timezone';
import FormCoverUpload from 'modules/galleryModules/components/FormCoverUpload';
import { FieldData } from 'rc-field-form/lib/interface';
import {
  createAskExpertArticle,
  getRepresentatives,
} from '../requests/expertArticlesRequests';
import TextEditor from 'modules/layoutModule/components/TextEditor/TextEditor';

const AskExpertsAdd = (): JSX.Element => {
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [form] = Form.useForm();
  const [fileImage1, setFileImage1] = useState<string | null>(null);
  const [fileImage2, setFileImage2] = useState<string | null>(null);
  const [fields, setFields] = useState<FieldData[]>([]);
  const [contentValue, setContentValue] = useState<string | undefined>('');
  const [representatives, setRepresentatives] = useState<any[]>([]);

  const onContentEdit = (e: any) => {
    setFields([
      {
        name: ['description'],
        value: e,
      },
    ]);
  };

  useEffect(() => {
    getRepresentatives().then((response) => {
      setRepresentatives([
        { label: '', value: '' },
        ...response.map((item: { name: string; id: number }) => ({
          label: item.name,
          value: item.id,
        })),
      ]);
    });
  }, []);

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  const onSubmitForm = (values: any) => {
    toggleButtonLoading(true);
    createAskExpertArticle(values).then(() => toggleButtonLoading(false));
  };

  const updateCover = (
    e: string,
    field: string,
    coverMethod: (value: string) => void
  ) => {
    setFields([
      {
        name: [field],
        value: e,
      },
    ]);
    coverMethod(e);
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Wiedza</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/ask-expert">Zapytaj eksperta</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/ask-expert/add">Dodaj</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <div className="site-layout-background">
        <ConfigProvider locale={plPL}>
          <Form
            layout="vertical"
            validateMessages={validateMessages}
            onFinish={onSubmitForm}
            form={form}
            fields={fields}
          >
            <Form.Item
              name="fileImage1"
              label="Avatar Porady ekspertów 543x547px"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <FormCoverUpload
                cover={fileImage1}
                setCover={(e) => updateCover(e, 'fileImage1', setFileImage1)}
                isNew
                field="fileImage1"
                number={1}
                hideTags
                dontResize
              />
            </Form.Item>
            <Form.Item
              name="fileImage2"
              label="Avatar zapytaj eksperta 430x370px"
            >
              <FormCoverUpload
                cover={fileImage2}
                setCover={(e) => updateCover(e, 'fileImage2', setFileImage2)}
                isNew
                field="fileImage2"
                number={2}
                hideTags
                dontResize
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Imię i nazwisko"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name="description" label="Opis">
              <TextEditor
                initialValue={contentValue}
                onChange={onContentEdit}
                disableGallery
              />
            </Form.Item>
            <Form.Item name="categories" label="Kategoria">
              <Input />
            </Form.Item>

            <Form.Item name="idRepresentatives" label="Powiązany z PT">
              <Select
                showSearch
                placeholder="Wybierz jedną z opcji"
                optionFilterProp="children"
                options={representatives}
                filterOption={(input, option) => {
                  // @ts-ignore
                  if (option?.label) {
                    // @ts-ignore
                    return option.label
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>

            <Form.Item
              name="sortOrder"
              label="Kolejność"
              rules={[
                {
                  required: true,
                },
                {
                  validator: async (_, value) => {
                    if (value) {
                      if (
                        (value.length > 5 ||
                          !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                        value.length > 0
                      ) {
                        return Promise.reject(
                          new Error('Proszę podać poprawną wartość!')
                        );
                      }
                    }
                  },
                },
              ]}
            >
              <Input
                style={{
                  width: '100px',
                }}
              />
            </Form.Item>
            <Form.Item
              name="isActive"
              label="Twórca Porad ekspertów"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item
              name="ask"
              label="Widoczny na podstronie Zapytaj eksperta"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>
            <Form.Item>
              <Space>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                  loading={isSaveButtonLoading}
                >
                  Zapisz
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </ConfigProvider>
      </div>
    </>
  );
};

export default AskExpertsAdd;
